import type { ChangeEvent } from 'react';
import type { Filters } from '@/domain';

export type CheckboxFilterProps = {
    filterType: string;
    filterData: string[];
    filterValues: string[];
    onFilterChanged: (filters: Filters) => void;
};

export const CheckboxFilter = ({ filterData, filterValues, filterType, onFilterChanged }: CheckboxFilterProps) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>, checkedItem: string): void => {
        const checkedFilters = filterValues.filter((item) => item !== checkedItem);
        if (event.target.checked) {
            checkedFilters.push(checkedItem);
        }
        const filterObject = {};
        filterObject[filterType] = checkedFilters;
        onFilterChanged(filterObject);
    };

    const isChecked = (type: string): boolean => !!filterValues && filterValues.indexOf(type) !== -1;

    return (
        <>
            {filterData.map((item) => (
                <div className="input-toggle" key={item}>
                    <input
                        type="checkbox"
                        id={`${filterType}-${item}`}
                        value={item}
                        checked={isChecked(item)}
                        onChange={(event) => handleChange(event, item)}
                        data-testid={`${filterType}-${item}`}
                    />
                    <label htmlFor={`${filterType}-${item}`}>{item}</label>
                </div>
            ))}
        </>
    );
};
